module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_White-ba780b0393f46ee4817a4db66f030fea.png";